import React, { FC } from 'react';
import { createUseStyles } from '../theming';
import clsx from 'clsx';

interface Props {
  label: string;
  className?: any;
  style?: any;
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1rem',
  },
  label: {
    fontWeight: 400,
    color: '#868686',
    marginBottom: 0,
  },
});

const ComponentWithLabel: FC<Props> = ({ label, children, className, style }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} style={style}>
      <label className={classes.label}>{label}</label>
      {children}
    </div>
  );
};

export default ComponentWithLabel;
